export const mapApiDataToStores = (getResponse) => {
  let userInfo;
  let authorizedOfficerInfo;
  let companyInfo;

  const extractUserInfo = () => {
    const systemAdministrator = getResponse?.data?.systemAdministrator;
    userInfo = {
      firstName: systemAdministrator?.firstName ?? '',
      lastName: systemAdministrator?.lastName ?? '',
      jobTitle: systemAdministrator?.jobTitle ?? '',
      email: systemAdministrator?.email ?? '',
      businessPhone: systemAdministrator?.workPhone ?? '',
      extension: systemAdministrator?.extension ?? '',
      cellPhone: systemAdministrator?.cellPhone ?? '',
    };
  };

  const extractAuthorizedOfficerInfo = () => {
    const authorizedOfficer = getResponse?.data?.authorizedOfficerInfo;
    authorizedOfficerInfo = {
      firstName: authorizedOfficer?.firstName ?? '',
      lastName: authorizedOfficer?.lastName ?? '',
      jobTitle: authorizedOfficer?.jobTitle ?? '',
      email: authorizedOfficer?.email ?? '',
      businessPhone: authorizedOfficer?.workPhone ?? '',
      extension: authorizedOfficer?.extension ?? '',
      cellPhone: authorizedOfficer?.cellPhone ?? '',
    };
  };

  const extractCompanyInfo = () => {
    const companyInformationResponse = getResponse?.data?.companyInformationResponse;
    companyInfo = {
      entityName: companyInformationResponse?.legalName ?? '',
      taxId: companyInformationResponse?.taxIdNumber ?? '',
      dba: companyInformationResponse?.buyerDBAName ?? '',
      corporatePhone: companyInformationResponse?.phoneNumber?.number ?? '',
      extension: companyInformationResponse?.phoneNumber?.extension ?? '',
      street1: companyInformationResponse?.address?.streetAddressLine1 ?? '',
      street2: companyInformationResponse?.address?.streetAddressLine2 ?? '',
      city: companyInformationResponse?.address?.city ?? '',
      state: companyInformationResponse?.address?.state ?? '',
      zip: companyInformationResponse?.address?.postalCode ?? '',
      country: companyInformationResponse?.address?.country ?? '',
    };
  };

  const determineAuthorizedOfficer = () => {
    const authorizedOfficer = getResponse?.data?.authorizedOfficerInfo;
    const systemAdministrator = getResponse?.data?.systemAdministrator;

    if (authorizedOfficer == null || (authorizedOfficer?.email === systemAdministrator?.email)) {
      userInfo.authorizedOfficer = true;
    } else {
      userInfo.authorizedOfficer = false;
    }
  };

  if (getResponse.data != null) {
    extractUserInfo();
    extractAuthorizedOfficerInfo();
    extractCompanyInfo();
  }

  determineAuthorizedOfficer();

  return [userInfo, authorizedOfficerInfo, companyInfo];
};
